"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import LinkButton from "@/components/ui/Link";
import Nav from "./Nav";
import logoIcon from "../../../public/logo.svg";
import { useUserStore } from "@/stores/useAuthStore";
import { useMySubscription } from "@/queries/subscription";
import { useScrollHide } from "./useScrollHide";
import { useLogout } from "./useLogout";
import { HeaderDesktopRight } from "./HeaderDesktopRight";
import { HeaderMobileAuth } from "./HeaderMobileAuth";
const HEADER_GRADIENT = "linear-gradient(180deg, rgba(13, 13, 27, 0.7) 0%, rgba(13, 13, 27, 0.59) 13.69%, rgba(13, 13, 27, 0.58) 25.27%, rgba(13, 13, 27, 0.55) 34.98%, rgba(13, 13, 27, 0.52) 43.09%, rgba(13, 13, 27, 0.48) 49.86%, rgba(13, 13, 27, 0.43) 55.53%, rgba(13, 13, 27, 0.38) 60.38%, rgba(13, 13, 27, 0.33) 64.65%, rgba(13, 13, 27, 0.28) 68.6%, rgba(13, 13, 27, 0.22) 72.49%, rgba(13, 13, 27, 0.17) 76.57%, rgba(13, 13, 27, 0.12) 81.11%, rgba(13, 13, 27, 0.08) 86.35%, rgba(13, 13, 27, 0.03) 92.57%, rgba(13, 13, 27, 0) 100%)";
const Header = () => {
  const $ = _c(19);
  const hidden = useScrollHide();
  const handleLogout = useLogout();
  const {
    userProfile,
    isLoggedIn,
    activeProfile
  } = useUserStore();
  const {
    data: subscriptionData
  } = useMySubscription(isLoggedIn);
  const hasActiveSubscription = isLoggedIn && subscriptionData?.data?.is_active === true;
  const displayName = activeProfile?.name ?? userProfile?.first_name ?? "";
  const t0 = `fixed left-0 right-0 inset-0 z-[60] h-[55px] md:bg-secondary/5 transition-all duration-300 ease-out ${hidden ? "-top-[0] md:backdrop-blur-md" : "top-0"}`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      background: HEADER_GRADIENT
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LinkButton href="/" className="flex items-center me-0 md:me-8" title="" size="none" variant="default"><Image src={logoIcon} width={28} height={28} alt="" loading="lazy" /><h2 className="text-lg">ایده نما</h2></LinkButton>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center">{t2}<div className="hidden md:flex"><Nav /></div></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = isLoggedIn && !!userProfile;
  const t5 = subscriptionData?.data?.days_left;
  let t6;
  if ($[3] !== displayName || $[4] !== hasActiveSubscription || $[5] !== t4 || $[6] !== t5) {
    t6 = <HeaderDesktopRight isLoggedIn={t4} displayName={displayName} hasActiveSubscription={hasActiveSubscription} daysLeft={t5} />;
    $[3] = displayName;
    $[4] = hasActiveSubscription;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = isLoggedIn && !!userProfile;
  let t8;
  if ($[8] !== displayName || $[9] !== handleLogout || $[10] !== hasActiveSubscription || $[11] !== t7) {
    t8 = <div className="flex md:hidden"><HeaderMobileAuth isLoggedIn={t7} displayName={displayName} hasActiveSubscription={hasActiveSubscription} onLogout={handleLogout} /></div>;
    $[8] = displayName;
    $[9] = handleLogout;
    $[10] = hasActiveSubscription;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t8) {
    t9 = <div className="mx-auto container max-w-3xl px-5 md:px-12 h-full flex items-center justify-between">{t3}{t6}{t8}</div>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t0 || $[17] !== t9) {
    t10 = <header className={t0} style={t1}>{t9}</header>;
    $[16] = t0;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
export default Header;